import { FC } from 'react';
import { EventProps } from 'react-big-calendar';

import cs from 'classnames';
import { format } from 'date-fns';

import { CalendarEvent, SlotType } from 'types/interviewSlots';

import styles from './MonthEvent.module.scss';

const MonthEvent: FC<EventProps<CalendarEvent>> = ({ event }) => {
  const startTime = format(event.start, 'h:mm a');
  const endTime = format(event.end, 'h:mm a');
  const timeRange = `${startTime} - ${endTime}`;

  const isSelected = event.type === SlotType.Selected;
  const isProposed = event.type === SlotType.Proposed;

  return (
    <div
      className={cs(styles.monthEvent, {
        [styles.selected]: isSelected,
        [styles.proposed]: isProposed
      })}
    >
      <span className={styles.timeRange}>{timeRange}</span>
    </div>
  );
};

export default MonthEvent;
